import template from './kp-side-menu.tpl.pug';
import './kp-side-menu.less';


/**
 * @ngdoc component
 * @name kpSideMenu
 * @module portaro.components.main-menu
 *
 * @param {boolean} isOpen Control variable for open/close side menu.
 * @param {Array<menuItem>} menuItems Menu definition
 *
 * @description
 * Component for mobile version of {@link component:kpMainMenu kpMainMenu}
 *
 * @example
 * ```
 *  <button type="button" ng-click="isOpen = !isOpen" ng-init="isOpen = false">Toggle Menu</button>
 *  <kp-side-menu menuItems="[...]" is-open="isOpen" />
 * ```
 */
class SideMenuComponentController {
    menuElement;

    /*@ngInject*/
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;
    }

    $postLink() {
        this.menuElement = this.$element[0].querySelector('.kp-mm-nav-responsive');

        this.menuWidth = this.menuElement.offsetWidth;
        this.menuElement.style.left = `${0 - this.menuWidth}px`;
    }
}

export default class SideMenuComponent {
    static componentName = 'kpSideMenu';

    bindings = {
        menuItems: '<',
        isOpen: '='
    };

    templateUrl = template;
    controller = SideMenuComponentController;
    controllerAs = 'smcc';
}